<template>
  <app-layout>
    <div class="page-gift-landing">
      <section
        class="gift-landing-form-section flex flex-col lg:justify-center"
      >
        <div
          class="titles mx-auto text-white flex flex-col justify-center flex-grow lg:grow-0 lg:mb-16"
        >
          <h1 class="text-center my-10">{{ $t('give_away_avm.title') }}</h1>
          <p class="text-center">
            {{ $t('gifts.buy_this_gift') }}
          </p>
        </div>
        <v-form
          ref="form"
          v-model="form.valid"
          class="gift-landing-form mx-auto flex flex-col justify-center lg:flex-row lg:items-center grow-0 pt-6 pb-12 lg:px-4"
        >
          <div class="input-container lg:w-2/5 md:w-1/1 md:px-2">
            <label class="hidden lg:inline-block ml-4 pb-2">{{ $t('shared.where_from') }}</label>
            <v-select
              class="js-prepend-custom-icons js-replace-arrows"
              :items="locations"
              prepend-inner-icon="airplane"
              v-model="form.from.value"
              :placeholder="$t('shared.where_from')"
              outlined
              rounded
              background-color="#fff"
              hide-details
              item-value="id"
              item-text="name"
              height="50"
              required
              :no-data-text="$t('shared.loading_cities') + '...'"
            ></v-select>
          </div>
          <div class="input-container lg:w-2/5 md:w-1/1 md:px-2">
            <label class="hidden lg:inline-block ml-4 pb-2">{{ ucfirst($tc('shared.person', 2)) }}</label>
            <v-select
              class="js-prepend-custom-icons js-replace-arrows"
              :items="personsItems"
              prepend-inner-icon="user"
              v-model="form.persons.value"
              :placeholder="$tc('shared.person', 2)"
              outlined
              rounded
              background-color="#fff"
              hide-details
              height="50"
            ></v-select>
          </div>
          <div class="btn-container md:w-1/1 md:px-2" style="padding: 2px 0">
            <v-btn
              @click="search"
              rounded
              elevation="0"
              color="secondary"
              class="avm-btn w-full"
              :class="{ disabled: !form.from.value }"
              >{{ $t('gifts.start') }}</v-btn
            >
          </div>
        </v-form>
      </section>
      <app-section-info-icons></app-section-info-icons>
      <last-posts-component></last-posts-component>
      <app-section-brands></app-section-brands>
      <app-banner-newsletter
        background="/img/background-image-newsletter.jpg"
      ></app-banner-newsletter>
    </div>
  </app-layout>
</template>

<script lang="ts">
import { LOAD_GIFTS_LOCATIONS } from "../../store/gifts/action-types";
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";
import { GIFTS_GET_ORIGINS_WITH_DESTINATIONS } from "../../store/gifts/getter-types";
import prependCustomIcons from '../../utils/mixins/prependCustomIcons';
import replaceArrows from '../../utils/mixins/replaceArrows';
import axios from 'axios';
import { ucfirst } from '../../utils/strings';

export default {
  mixins: [prependCustomIcons, replaceArrows],
  data() {
    return {
      form: {
        from: {
          value: this.$store.state.gifts.origin_id,
        },
        persons: {
          value: this.$store.state.gifts.passengers,
        },
      },
      ucfirst,
    };
  },
  computed: {
    locations() {
      return this.$store.getters[GIFTS_GET_ORIGINS_WITH_DESTINATIONS];
    },
    personsItems() {
      let options = [];

      for (let i = 1; i <= 10; i++) {
        options.push({
          text: i + " " + this.$tc('shared.person', i),
          value: i,
        });
      }
      return options;
    },
  },
  methods: {
    getPosts(){
      let me =this;
      let url = '/blog';
      axios.get(url).then(function (response) {
                    //creamos un array y guardamos el contenido que nos devuelve el response
                    me.arrayTasks = response.data;
                })
    },
    search() {
      if (!this.form.from.value) return;

      this.$router.push("/regala/destinos");
    },
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        this.$store.commit(SET_GIFTS_STATE, {
          prop: "origin_id",
          value: form.from.value,
        });
        this.$store.commit(SET_GIFTS_STATE, {
          prop: "passengers",
          value: form.persons.value,
        });
      },
    },
  },
  created() {
    this.$store.dispatch(LOAD_GIFTS_LOCATIONS);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.page-gift-landing {
  .gift-landing-form-section {
    height: calc(100vw * 668 / 375);
    max-height: calc(100vh - 120px);
    background-image: url("/img/background-landing-gift-mobile.png");
    background-size: cover;

    @media (min-width: 376px) {
      background-image: url("/img/background-landing-gift.png");
      background-position: center 0;
      height: 768px;
    }
    @media (min-width: 960px) {
      max-height: calc(100vh - 64px);
    }
    @media (min-width: 1024px) and (orientation: landscape) {
      height: calc(100vh - 64px);
    }

    .titles {
      width: 90%;
      max-width: 1200px;

      h1 {
        font-size: 30px;
        font-weight: 900;
        line-height: 1.33;
        @media (min-width: 1024px) {
          font-size: 45px;
          line-height: 1.22;
        }
      }

      p {
        font-size: 18px;
        font-weight: 900;
        line-height: 1.44;
        @media (min-width: 1024px) {
          font-size: 25px;
        }
      }
    }

    .gift-landing-form {
      width: 90%;
      max-width: 1000px;

      @media (min-width: 1024px) {
        padding-top: 20px !important;
        padding-bottom: 30px !important;
        margin-bottom: 5%;
        background: white;
        border-radius: 15px;
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
      }

      label {
        font-size: 18px;
        font-weight: 900;
      }

      .v-input {
        height: 75px;
        @media (min-width: 1024px) {
          height: 50px;
        }
      }

      .btn-container {
        height: 50px;
        @media (min-width: 1024px) {
          align-self: flex-end;
        }

        .avm-btn {
          &.disabled {
            pointer-events: none;
            background: #c2c2c2 !important;
          }
        }
      }
    }
  }
}
</style>
